import {  useUserState } from '#core/state/UserState.ts';
import { createFileRoute, Navigate } from '@tanstack/react-router'
import { NoCompanyLanding } from '#components/domain/auth/user/shared/no-company-landing.tsx'
import { CompanySelectLanding } from '#components/domain/auth/user/shared/company-select-landing.tsx'
import { LoginRedirect } from '#components/tools/login-redirect.tsx'
import { CompanyUnlockScreen } from '#components/entities/users/company-lock/company-unlock-screen.tsx'

export const Route = createFileRoute('/')({
  component: RouteComponent,
})

function RouteComponent() {  
  const userState = useUserState(); //userstate will validate itself on page load
  if(userState.loginState == 'success'){
    const companyRoles = userState.user?.roles?.filter(f => f.company_id != null) ?? [];
    if(companyRoles.length === 1){
      // Land on the human-readable company code, not the GUID. Match the company to *this*
      // role's company_id (companies[0] is not guaranteed to be the role's company), and only
      // fall back to the GUID when the code is genuinely unavailable — `||` so an empty code
      // ("") falls back too. The GUID still routes correctly and gets upgraded to the code by
      // useCanonicalCompanyUrl once resolvable.
      const companyId = companyRoles[0].company_id;
      if(userState.isLocked(companyId))
        return <CompanyUnlockScreen companyId={companyId} />
      const company = userState.user?.companies?.find(
        (c) => c.id?.toLowerCase() === companyId?.toLowerCase()
      );
      const segment = company?.code || companyId;
      return <Navigate to={"/"+segment+"/"}></Navigate>
    } else if(companyRoles.length === 0){
      // Attached to no company (their account has no company role, or the super user
      // holds none): show the company-less landing here rather than a dead end.
      return <NoCompanyLanding />
    }
    else return <CompanySelectLanding />
  }else if (userState.loginState == 'pending'){
    return <div>Loading...</div>
  }else if (userState.loginState == 'failed'){
    return <LoginRedirect />
  }
  else return<div>This application doesn't work without service workers</div>
}
